import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "showInfoIcon"];
// copied from: https://git.hubteam.com/HubSpot/ui-addon-conversations-settings/blob/3c89aee1836bb1efd278f39f1bb316d4f77c6c81/static/js/components/message/AgentSelectItem.tsx
import get from 'transmute/get';
import UIIcon from 'UIComponents/icon/UIIcon';
import TeamContainsFreeUsersTooltip from './tooltips/TeamContainsFreeUsersTooltip';
import FreeUserRoutingTooltip from './tooltips/FreeUserRoutingTooltip';
import FreeUserDowngradedTooltip from '../../routing-rules/components/tooltips/FreeUserDowngradedTooltip';
import RemovedFromInboxUserTooltip from '../../routing-rules/components/tooltips/RemovedFromInboxUserTooltip';
import RemovedFromPortalUserTooltip from '../../routing-rules/components/tooltips/RemovedFromPortalUserTooltip';
import { checkIsUserOption } from '../../routing-rules/utils/checkIsUserOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AgentItemContainer = _ref => {
  let {
      children,
      className,
      showInfoIcon = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("span", Object.assign({}, rest, {
    className: `${className} align-center justify-between`,
    children: [children, showInfoIcon && /*#__PURE__*/_jsx(UIIcon, {
      name: "info",
      className: "m-right-4"
    })]
  }));
};
AgentItemContainer.displayName = 'AgentSelectItemContainer';
const AgentSelectItem = props => {
  const {
    option,
    children,
    inboxId,
    isOptionItemInDropdown = false,
    isNewSeatingModel = false
  } = props;
  // this is used to render an option in the dropdown list
  if (isOptionItemInDropdown) {
    const isHiddenUser = get('hidden', option);
    const isFreeUser = get('isFreeUser', option);
    const containsFreeUsers = get('containsFreeUsers', option);
    const isRoutableUser = get('routable', option);
    if (isHiddenUser || isNewSeatingModel && checkIsUserOption(option) && !isRoutableUser) {
      return null;
    }
    if (isFreeUser) {
      return /*#__PURE__*/_jsx(FreeUserRoutingTooltip, {
        userName: option.text,
        children: /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, props, {
          showInfoIcon: true
        }))
      });
    }
    if (containsFreeUsers) {
      return /*#__PURE__*/_jsx(TeamContainsFreeUsersTooltip, {
        isNewSeatingModel: isNewSeatingModel,
        children: /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, props, {
          showInfoIcon: true
        }))
      });
    }

    // regular assignable users or teams, don't show a tooltip
    return /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, props));
  }

  // this option is a user
  if (checkIsUserOption(option)) {
    if (!get('userInPortal', option)) {
      return /*#__PURE__*/_jsx(RemovedFromPortalUserTooltip, {
        children: children
      });
    }
    if (!get('canViewInbox', option)) {
      return /*#__PURE__*/_jsx(RemovedFromInboxUserTooltip, {
        inboxId: inboxId || '',
        children: children
      });
    }
    if (!get('routable', option)) {
      return /*#__PURE__*/_jsx(FreeUserDowngradedTooltip, {
        isNewSeatingModel: isNewSeatingModel,
        children: children
      });
    }
  }

  // this option is a team or a regular assignable user, don't show a tooltip
  return /*#__PURE__*/_jsx(AgentItemContainer, Object.assign({}, props));
};
AgentSelectItem.displayName = 'AgentSelectItem';
export default AgentSelectItem;